/**
 * Rep "My leads" API surface — thin wrappers over the shared credentialed `http`
 * client (sends cookies, unwraps `{ success, data }`, maps 401/403/404/409 to
 * typed errors). Every route is `/api/com/rep/leads/*`.
 *
 * Workspace scope is NEVER sent from the client: the backend derives the rep's
 * single workspace from the JWT (`resolveWorkspaceId`), ignoring any client id
 * (BR-13). The list returns a bare array (not paginated).
 */
import { http } from '@teivor/shared-utils/api';

import type { RepTask } from './types';

export const repLeadsApi = {
  list: () => http.get<RepTask[]>('/api/com/rep/leads'),
  detail: (taskId: string) => http.get<RepTask>(`/api/com/rep/leads/${taskId}`),
  markWorked: (taskId: string, version: number) =>
    http.patch<RepTask>(`/api/com/rep/leads/${taskId}/worked`, { version }),
  escalate: (taskId: string, version: number) =>
    http.patch<RepTask>(`/api/com/rep/leads/${taskId}/escalate`, { version }),
};
